import * as React from 'react';
import ImageComponent from '../Image';
import config from '../config';
const TRANSFORMATION_DELIMINETER = '-';
export const getMediaManagerUrl = (picture, width, height, script = 'resize', webp = false) => {
    if (!picture) {
        return '';
    }
    const transformOperations = [];
    if (picture.dimensions) {
        const { X, Y, W, H } = picture.dimensions;
        transformOperations.push(`${X}x${Y}x${W}x${H}`);
    }
    transformOperations.push(`${width}x${height}x${script}`);
    const size = transformOperations.join(TRANSFORMATION_DELIMINETER);
    let url = '';
    if (picture.media_url) {
        url = picture.media_url.replace('{size}', size);
    }
    else if (picture.uri) {
        url = `${config.MEDIAMANAGER_URL}/images/${size}/${picture.uri}`;
    }
    if (url && webp && !url.endsWith('.webp')) {
        url = `${url}.webp`;
    }
    return url;
};
export const generateSourcesForMmImage = (picture, naturalWidth, naturalHeight, sources, script, webp = false) => {
    const originalRatio = naturalWidth > 0 && naturalHeight > 0 ? naturalWidth / naturalHeight : 0;
    return (sources || []).map(item => {
        const pic = {
            ...picture,
            dimensions: item.dimensions || picture.dimensions,
        };
        const src = getMediaManagerUrl(pic, item.naturalWidth, originalRatio > 0 ? Math.round(item.naturalWidth / originalRatio) : 0, script, webp);
        return {
            srcSet: `${src}`,
            media: item.media,
            type: webp ? 'image/webp' : undefined,
        };
    });
};
const MediaManagerImage = ({ picture, script, naturalHeight, naturalWidth, webp, sources = [], onLoad, ...restProps }) => {
    const handleLoad = (e) => {
        if (!!e && typeof onLoad === 'function') {
            const { naturalWidth, naturalHeight } = e.target;
            onLoad({ naturalWidth, naturalHeight });
        }
    };
    if (webp) {
        let heightParsed = restProps.height;
        if (heightParsed && !Number.isNaN(Number(heightParsed))) {
            heightParsed = `${heightParsed}px`;
        }
        let widthParsed = restProps.width;
        if (widthParsed && !Number.isNaN(Number(widthParsed))) {
            widthParsed = `${widthParsed}px`;
        }
        if (picture.public_url?.endsWith('.svg')) {
            const src = getMediaManagerUrl(picture, naturalWidth, naturalHeight, script);
            return (React.createElement("picture", { className: restProps.className },
                React.createElement("img", { alt: restProps.alt, src: src, onLoad: handleLoad, loading: restProps.loading })));
        }
        else {
            const fallbackSrc = getMediaManagerUrl(picture, naturalWidth, naturalHeight, script);
            const matchedSource = (sources || []).find(item => item.naturalWidth === naturalWidth);
            const preparedSources = [];
            if (!matchedSource) {
                preparedSources.push({
                    naturalWidth,
                }, ...sources);
            }
            else {
                preparedSources.push(...sources);
            }
            const sourcesWebp = generateSourcesForMmImage(picture, naturalWidth, naturalHeight, preparedSources, script, webp);
            let sourcesFallback = [];
            if (sources.length > 0) {
                sourcesFallback = generateSourcesForMmImage(picture, naturalWidth, naturalHeight, preparedSources, script);
            }
            return (React.createElement("picture", { className: restProps.className, onLoad: handleLoad },
                [...sourcesWebp, ...sourcesFallback].map((sourceItem, idx) => (React.createElement("source", { key: `${sourceItem.srcSet}-${idx}`, ...sourceItem }))),
                React.createElement("img", { alt: restProps.alt, src: fallbackSrc, height: heightParsed, width: widthParsed, loading: restProps.loading, style: { maxWidth: '100%' } })));
        }
    }
    const src = getMediaManagerUrl(picture, naturalWidth, naturalHeight, script, webp);
    return (React.createElement(ImageComponent, { ...restProps, src: src || '', onLoadComplete: onLoad }));
};
export default MediaManagerImage;
